import * as React from 'react'
import { Modal, Input, Label, Button } from '@/shared/ui'
import type { CryptoAsset } from '@/modules/crypto-assets/services/cryptoAssetsService'

export type EditAssetNameModalProps = {
  open: boolean
  asset: CryptoAsset | null
  onOpenChange: (v: boolean) => void
  onSave: (name: string) => Promise<void> | void
}

export function EditAssetNameModal({ open, asset, onOpenChange, onSave }: EditAssetNameModalProps){
  const [name, setName] = React.useState('')
  const [saving, setSaving] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(()=>{
    setError(null)
    if (open && asset) setName((asset.name || '').trim())
  }, [open, asset?.id])

  const base = (asset?.base_asset || asset?.symbol || '').replace(/USDT$/,'')
  const placeholder = base || 'Ex.: BTC, ETH, AAVE'

  async function handleSave(){
    const n = name.trim()
    if (n.length < 2 || n.length > 50) { setError('Informe entre 2 e 50 caracteres'); return }
    try {
      setSaving(true)
      setError(null)
      await onSave(n)
      onOpenChange(false)
    } catch (e:any) {
      setError(e?.message || 'Falha ao salvar')
    } finally { setSaving(false) }
  }

  return (
    <Modal open={open} onOpenChange={onOpenChange} className="p-6 sm:p-8" style={{ width: 480, maxWidth: 480 }}>
      <div className="mb-2 text-lg font-semibold">Editar nome do ativo</div>
      {asset && (<div className="mb-3 text-sm text-foreground/70">Ativo: <b>{asset.symbol}</b></div>)}
      <div className="space-y-2">
        <Label className="text-xs">Nome</Label>
        <Input value={name} onChange={(e)=> setName(e.target.value)} placeholder={placeholder} />
        {error && <div className="text-xs text-destructive-foreground/90">{error}</div>}
      </div>
      <div className="mt-4 flex items-center justify-end gap-2">
        <Button variant="ghost" onClick={()=> onOpenChange(false)}>Cancelar</Button>
        <Button onClick={handleSave} disabled={saving}>{saving?'Salvando...':'Salvar'}</Button>
      </div>
    </Modal>
  )
}

